export default __webpack_public_path__ + "static/media/recalculate.3c9512ac.ico";